export default {
    type: 'numeric',
    format: {
        percent: true,
        decimals: 0,
        min: 0,
        max: 100
    },
    default: {
        logic: 'max',
        value: 25
    },
    setting: {
        logic: ['max']
    },
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game'],
        linkOnly: true
    },
    lang: {
        name: 'Not Recommended Threshold',
        category: 'BGG',
        description: 'Ignore counts that exceed percentage threshold of not recommended votes.',
        summarise: {
            prefix: 'not recommended votes'
        }
    },
    rules: {
        linked: [],
        legacy: ['threshold.notrecommended']
    }
}